export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/web_analytics.9958e6f.svg";